import { styled, Typography } from "@mui/material"

export const TitleTypography = styled(Typography) ({
  padding: '16px 0 8px 16px',
  borderBottom: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  fontSize: '20px',
  fontFamily: 'Roboto',
})

export const LabelTypography = styled(Typography) ({
  color: 'black',
  fontSize: '14px',
  fontFamily: 'Roboto',
  fontWeight: 'Regular',
  lineHeight: '14px',
  minWidth: '100px',
})

export const ValueTypography = styled(Typography) ({
  paddingLeft: '32px',
  fontFamily: 'Roboto',
  fontSize: '14px',
  lineHeight: '14px',
})

export const SummaryTotalTypography = styled(Typography) ({
  padding: '16px 20px 6px 0',
  borderBottom: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  variant: "h2",
  component: "div",
  fontSize: '16px',
  fontFamily: 'Roboto',
  lineHeight: '32px',
  color: 'black',
})

export const SummaryPriceTypography = styled(Typography) ({
  fontSize: '14px',
  textAlign: 'right',
})